<template>
    <div id="contactNav">
        <div class="contNavTitle">
            <div>
                联系我们
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen2',
}
</script>

<style scoped>
    #contactNav{
        background: #edf0f5;
    }
</style>
